<template>
  <div class="panel-components-hidden-elements" v-show="this.show">
    <div class="he-heading">
      <h5>{{ $t(`ct-hidden-elements`)}}</h5>
    </div>
    <div class="place-for-elements-hidden">
      <div class="he-container">
        <div v-for="(element, index) in elements" :key="index" v-bind:data-reference="element.id">
          <div class="element-to-show" 
              @mouseover="fakeShowElement(element.id)"
              @mouseleave="fakeHideElement(element.id)">
            {{ $t(`ct-component-${element.name}`) }}
            {{ element.order }}
            <font-awesome-icon class="font-awesome-icon" :icon="['fas', 'eye']"
                              @click="showElement(element.id)"/>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'HiddenElementsSidebarComponent',
    props: [],
    components: {},
    data() {
      return {
        elements: [],
        show: false
      }
    },
    methods: {
      toggle() {
      },
      showPanel() {
        this.show = !this.show;
        return this.show;
      },
      hidePanel() {
        this.show = false;
        return this.show;
      },

      fakeShowElement(id) {
        $('#' + id).addClass('fake-show');
        try {

          const y = document.getElementById(id).getBoundingClientRect().top + window.scrollY - 70;
          window.scroll({
            top: y,
            behavior: 'smooth'
          });
        } catch (e) {

        }
      },
      fakeHideElement(id) {
        $('#' + id).removeClass('fake-show');
      },
      showElement(id) {
        $('[data-reference=' + id + ']').hide();
        this.$root.$emit('toggleElementById', id);
      },
      refillTab(device) {
        $('[data-reference]').show();
        let vm = this;
        vm.elements = [];

        // Coleta os elementos
        let elements = [
            ...document.getElementsByClassName('sitebuilder-element-container'),
            ...document.getElementsByClassName('panel')
        ];

        // Filtra os elementos com base no dispositivo e adiciona a um array temporário
        let filteredElements = [];
        [].forEach.call(elements, function (el) {
            if (device === 'desktop' && el.dataset.hideDesktop === "true") {
                filteredElements.push({
                    name: el.getAttribute('element'),
                    id: el.id,
                    order: JSON.parse(new DOMParser().parseFromString(el.getAttribute("config-properties"), "text/html").documentElement.textContent).hideDesktopOrder || null
                });
            } else if (device !== 'desktop' && el.dataset.hideMobile === "true") {
                filteredElements.push({
                    name: el.getAttribute('element'),
                    id: el.id,
                    order: JSON.parse(new DOMParser().parseFromString(el.getAttribute("config-properties"), "text/html").documentElement.textContent).hideMobileOrder || null
                });
            }
        });

        // Ordena os elementos pela ordem definida
        filteredElements.sort((a, b) => a.order - b.order);

        // Adiciona os elementos ordenados a vm.elements
        vm.elements = filteredElements.map(el => ({ name: el.name, id: el.id , order: el.order}));
      },
        close() {
        let vm = this;
        vm.show = false;
      }
    },
    mounted() {
      let vm = this;
      this.$root.$on('showHiddenElementsBar', function (device) {
        vm.show = !vm.show;
        vm.refillTab(device);
      });
      this.$root.$on('refillTabBar', function (device) {
        vm.refillTab(device);
      });
    }
  };

</script>

<style lang="scss" scoped>
  .he-container {
    min-height: 250px;
    max-height: 250px;
    overflow: hidden;
    overflow-y: auto;
  }


  .panel-components-hidden-elements {

    .element-to-show {
      border-top: 1px solid lightgray;
      padding: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
    }
  }

  [data-device='mobile'] {
    .panel-components-hidden-elements {

      > :after {
        left: 0 !important;
      }
    }
  }
</style>





// WEBPACK FOOTER //
// src/components/editor/base/sidebar/HiddenElementsSidebar.vue